import React, {Component} from 'react';
import {DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem} from 'reactstrap';
import PropTypes from 'prop-types';

import {AppHeaderDropdown} from '@coreui/react';
import Clock from 'react-live-clock';
import '../Reception/Style.css'
import {Label} from "semantic-ui-react";
import { Tooltip} from "antd";
import swal from "sweetalert";
import are_you_sure_icon from "../../assets/img/sweet/question.svg";
import Cookies from "js-cookie";
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import md_logo from  '../../assets/img/logos/md-logo.png';
import {withRouter} from 'react-router-dom'
import "./Style.css"
import * as routeConstants from "../../const/route/Route";


const propTypes = {
    children: PropTypes.node,
  };

const defaultProps = {};

class DefaultHeader extends Component {

    onLogout = () => {
        swal({
          title: "Do you want to sign out?",
          icon: are_you_sure_icon,
          closeOnClickOutside: false,
          buttons: {
            cancel: 'Cancel',
            dangerMode: {
              text: "Sign-out",
              value: "action",
              className: "remove-btn"
            }
          },
        })
          .then((value) => {
            switch (value) {

              case "action":

                this.props.userHandler([]);
                Cookies.remove("68a6102f6ed24899420170004a0273b8");
                Cookies.remove("9b8558ba3f051677daf36ebfc67f29fa");
                this.props.history.push('/');
                break;
              default:
            }
          });
      };

      render(){
          return(
              <React.Fragment>
                  <h1 className={"logo-text"}>
                    <img src={md_logo} className={"logo-style"} alt="." style={{height: '140px', marginTop: '-10px', marginLeft: '-30px'}}/>
                    </h1>
                    <Tooltip placement="topLeft" title="CheckIn Participants" >
                    <Label
                    onClick={() => this.props.history.push('/eventorganizer/dashboard')}
                    color='grey' horizontal
                    style={{cursor: 'pointer', marginLeft: '15px'}}
                    >
                      {"Check In"}
                    </Label>
                  </Tooltip>
                  <Tooltip placement="topLeft" title="Manage Participants" >
                    <Label
                    onClick={() => this.props.history.push('/eventorganizer/manage-participants')}
                    color='blue' horizontal
                    style={{cursor: 'pointer'}}
                    >
                      {"Manage Participants"}
                    </Label>
                  </Tooltip>
                <Tooltip placement="topLeft" title="Checked Participants" >
                  <Label
                    onClick={() => this.props.history.push('/eventorganizer/checked-participants')}
                    color='orange' horizontal
                    style={{cursor: 'pointer'}}
                  >
                    {"Checked Prticipants"}
                  </Label>
                </Tooltip>
                  <Tooltip placement="topLeft" title="Questions asked by Partcipants">
                    <Label
                    onClick={() => this.props.history.push('/eventorganizer/question-bank')}
                    color='blue' horizontal
                    style={{cursor: 'pointer'}}
                    >
                      {"Questions"}
                    </Label>
                  </Tooltip>
                  <Tooltip placement="topLeft" title="Open question screen">
                    <Label
                    onClick={() => window.open(routeConstants.QUESTION_BANK_ROUTE_PATH)}
                    color='red'  horizontal
                    style={{cursor: 'pointer'}}
                    >
                      {"Open Screen"}
                    </Label>
                  </Tooltip>
                    <Clock className="clock" format="dddd, D-MMMM-YYYY | h:mm:ss A"
                    ticking={true} interval={1000}/>

                <Nav className="ml-auto" navbar>
                    <AppHeaderDropdown direction="down">
                        <DropdownToggle nav>
                            <span
                                className = "dtoggle"
                            >{this.props.usr_obj === undefined ? "Welcome admin" : "Welcome " + this.props.usr_obj.fullName}
                                &nbsp;
                                <i className="fa fa-caret-down"/>
                            </span>

                        </DropdownToggle>
                        <DropdownMenu right style={{right: 'auto'}}>
                        <DropdownItem onClick={e => this.onLogout(e)}><i className="fa fa-lock"/> Logout</DropdownItem>
                        </DropdownMenu>
                    </AppHeaderDropdown>
                </Nav>
              </React.Fragment>
          );
      }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

const mapDispatchToProps = (dispatch) => {
    return {

      // spinner handler
      spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
      //user data handler:
      userHandler: (data) => dispatch(actionCreator.userHandler(data)),
      // userReducer
    };
  };

  export default connect(null, mapDispatchToProps)(withRouter(DefaultHeader));
